import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SubSubGroupTypeCategoryDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-subsubgrouptypecategory',
  templateUrl: './subsubgrouptypecategory.component.html',
  styleUrls: ['./subsubgrouptypecategory.component.scss'],
})
export class SubsubgrouptypecategoryComponent implements OnChanges {
  subsubgrouptypecategoryForm: FormGroup;
  subsubgrouptypecategoryFormArray: FormGroup;
  control = new FormControl();
  @Input() subsubgrouptypecategorys: SubSubGroupTypeCategoryDto[];
  @Input() routeAnimationsElements: any;
  @Output() subsubgrouptypecategory = new EventEmitter<
    SubSubGroupTypeCategoryDto[]
  >();
  @Output() deleteSubSubGroupTypeCategoryEvent = new EventEmitter<any>();

  selectedSubSubGroupTypeCategory: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createSubSubGroupTypeCategoryForm();
  }

  createSubSubGroupTypeCategoryForm() {
    this.subsubgrouptypecategoryForm = this.fb.group({
      SubSubGroupTypeCategoryName: ['', Validators.required],
      id: null,
    });
    this.subsubgrouptypecategoryFormArray = this.fb.group({
      SubSubGroupTypeCategorys: this.fb.array([]),
    });
    this.setSubSubGroupTypeCategory();
  }

  // method to display subsubgrouptypecategorys
  setSubSubGroupTypeCategory() {
    const control = this.subsubgrouptypecategoryFormArray.controls
      .SubSubGroupTypeCategorys as FormArray;
    this.subsubgrouptypecategorys.forEach((e) => {
      control.push(
        this.fb.group({
          SubSubGroupTypeCategoryName: e.SubSubGroupTypeCategoryName,
          id: e.id,
        })
      );
    });
  }

  // method to add SubSubGroupTypeCategory
  addSubSubGroupTypeCategory(value: SubSubGroupTypeCategoryDto) {
    const control = this.subsubgrouptypecategoryFormArray.controls
      .SubSubGroupTypeCategorys as FormArray;
    control.insert(
      0,
      this.fb.group({
        SubSubGroupTypeCategoryName: value.SubSubGroupTypeCategoryName,
        id: null,
      })
    );
  }

  selectSubSubGroupTypeCategory(value) {}

  // method to delete subsubgrouptypecategory from arrary list
  deleteSubSubGroupTypeCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.subsubgrouptypecategoryFormArray.controls
          .SubSubGroupTypeCategorys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.subsubgrouptypecategorys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.subsubgrouptypecategorys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: SubSubGroupTypeCategoryDto) {
    if (this.subsubgrouptypecategoryForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.subsubgrouptypecategoryFormArray
        .get('SubSubGroupTypeCategorys')
        ['controls'][this.selectedIndex].patchValue({
          SubSubGroupTypeCategoryName: formValue.SubSubGroupTypeCategoryName,
        });
    } else {
      this.addSubSubGroupTypeCategory(formValue);
    }
    this.selectedIndex = null;
    this.subsubgrouptypecategoryForm.reset();
  }

  onEdit(index, value: SubSubGroupTypeCategoryDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.subsubgrouptypecategoryForm.patchValue({
      SubSubGroupTypeCategoryName: value.SubSubGroupTypeCategoryName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.subsubgrouptypecategoryForm.reset();
  }

  onSubmit(formValue: SubSubGroupTypeCategoryDto[]) {
    this.subsubgrouptypecategory.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteSubSubGroupTypeCategoryEvent.emit(this.filteredDelete);
    }
  }
}
